import { useEffect, useState } from 'react';
import './App.css';
import JoinPage from './pages/join/JoinPage';
import i18next from 'i18next';
import { CampaignsGetResponse, CampaignsGetResponse_Campaign, CampaignsService } from './apis/api-client';
import LandingPage from './pages/landingpage/LandingPage';
import FiestaInfiniteSpinner from './shared/infinite-spinner/FiestaInfiniteSpinner';

function App() {

  const joinPageUrl = 'https://join.fiesta.club/';

  const [ logic, setLogic ] = useState<'eval' | 'join' | 'landingpage'>('eval');
  const [ key, setKey ] = useState<string>((new Date()).toISOString());
  const [ campaignData, setLandingpageData ] = useState<CampaignsGetResponse_Campaign | null>(null);

  useEffect(
    () => {
      evaluate();

      i18next.on(
        'languageChanged', (lng) => {
          document.documentElement.lang = lng;
          setKey((new Date()).toISOString());
        }
      );
    },
    []
  );

  /**
   * Evaluate, what to do with the page request.
   */
  function evaluate() {
    const hostName =
      process.env.REACT_APP_OVERWRITE_HOSTNAME
      ?? window.location.hostname;
    
    const hostParts =
      hostName.split('.');

    if (
      hostParts.length === 3
      && hostParts[1] === 'fiesta'
      && hostParts[2] === 'club'
    ) {
      if (hostParts[0] === 'join') {
        setLogic('join');
      } else {
        landingPage(hostParts[0]);
      }
    } else {
      redirectToWebsite();
    }
  }

  /**
   * Fetches the landingpage data.
   * @param subdomain The subdomain to fetch the landingpage for.
   */
  async function landingPage(subdomain: string) {
      await CampaignsService
        .getLandingpage(0, 1, true, subdomain)
        .then(
          (response: CampaignsGetResponse) => {
            if (
              response
              && response.result
              && response.result[0].landingpage
              && response.result[0].landingpage.domain == subdomain
            ) {
              setLandingpageData(response.result[0]);
              setLogic('landingpage');
            } else {
              redirectToJoin();
            }
          }
        )
        .catch(
          () => redirectToJoin()
        );
  }

  /**
   * Redirects the user to the website.
   */
  function redirectToWebsite() {
    window.location.href = 'https://fiesta.club/';
  }

  /**
   * Redirects the user to the join page.
   */
  function redirectToJoin() {
    window.location.href = 'https://join.fiesta.club/';
  }

  return (
    <>
      {
        logic === 'join'
        &&
        <JoinPage />
      }
      {
        logic === 'landingpage'
        && campaignData
        &&
        <LandingPage campaignData={campaignData} />
      }
      {
        logic === 'eval'
        &&
        <>
          <div style={{position: 'absolute', top: '50%', bottom: '50%', left: '50%', right: '50%'}}>
            <div style={{marginLeft: '-64px', marginTop: '-64px'}}>
              <FiestaInfiniteSpinner />
            </div>
          </div>
        </>
      }
    </>
  );
}

export default App;